import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledHeader = styled.div`
  height: 60px;
  border-radius: ${theme.variables.border_radius_1};
  box-shadow: 0px 2px 8px 0px rgba(74, 74, 79, 0.08);
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  margin: 12px 32px;

  & .right-content {
    background-color: transparent;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 25px;

    @media (max-width: ${({ theme }) => theme.breakpoints.SM}px) {
      gap: 10px;
    }
  }

  & .avatar-wrapper {
    @media (max-width: ${({ theme }) => theme.breakpoints.SM}px) {
      display: none;
    }
  }

  & .burger-menu-mobile {
    display: none;
    @media (max-width: ${({ theme }) => theme.breakpoints.SM}px) {
      display: flex;
      align-items: center;
    }
  }
`;
